const applicationSteps = [
  {
    "id": "0.0",
    "status": "Not started",
    "color": "#efefef",
    "restricted": false,
    "common": "Not started"
  },
  {
    "id": "0.1",
    "status": "Position cancelled (e.g. budget change)",
    "color": "#FF6B6B",
    "restricted": false
  },
  {
    "id": "0.2",
    "status": "Position is closed/fulfilled",
    "color": "#efefef",
    "text": "black",
    "restricted": false,
    "common": "Position closed/cancelled"
  },
  {
    "id": "1.1",
    "status": "Ready to be referred (I match some requirements)",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "1.2",
    "status": "Ready to be referred (I match all requirements)",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "1.21",
    "status": "To apply on the website, the referrer will be notified",
    "color": "#c4ecff",
    "text": "black",
    "restricted": true
  },
  {
    "id": "1.22",
    "status": "Ready to notify referrer (application submitted)",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "1.3",
    "status": "To apply with outside or no referral",
    "color": "#c4ecff",
    "text": "black",
    "restricted": true
  },
  {
    "id": "1.4",
    "status": "To apply if another position rejects",
    "color": "#c4ecff",
    "text": "black",
    "restricted": true
  },
  {
    "id": "1.5",
    "status": "To put on hold for now",
    "color": "#ffeab6",
    "text": "black",
    "restricted": false
  },
  {
    "id": "1.6",
    "status": "To add roles after the initial role's referral",
    "color": "#ffeab6",
    "text": "black",
    "restricted": false
  },
  {
    "id": "1.7",
    "status": "Pending fellow's action",
    "color": "#ffeab6",
    "text": "black",
    "restricted": true
  },
  {
    "id": "1.8",
    "status": "Pending Outtalent's action",
    "color": "#FFA94D",
    "restricted": true
  },
  {
    "id": "2.0",
    "status": "Request a referral",
    "color": "#FFD43B",
    "restricted": true
  },
  {
    "id": "2.1",
    "status": "Referral requested",
    "color": "#c4ecff",
    "text": "black",
    "restricted": true
  },
  {
    "id": "2.2",
    "status": "Applied without referral",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "2.3",
    "status": "Applied with non-Outtalent referral",
    "color": "#38D9A9",
    "restricted": false
  },
  {
    "id": "3.1",
    "status": "Referring person confirmed submission",
    "color": "#c1f5f0",
    "text": "black",
    "restricted": false
  },
  {
    "id": "3.2",
    "status": "Referring person rejected",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "4.0",
    "status": "Referral confirmation received by candidate",
    "color": "#cff5d1",
    "text": "black",
    "restricted": false
  },
  {
    "id": "5.0",
    "status": "Reviewed for another role",
    "color": "#d1e2ff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "5.1",
    "status": "Test assigned",
    "color": "#DA77F2",
    "restricted": false,
    "common": "Test stage"
  },
  {
    "id": "5.2",
    "status": "Resume rejected",
    "color": "#efefef",
    "text": "black",
    "restricted": false,
    "common": "Rejected"
  },
  {
    "id": "5.3",
    "status": "Resume considered for another role",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "6.0",
    "status": "Test submitted",
    "color": "#FFD43B",
    "restricted": false
  },
  {
    "id": "6.1",
    "status": "Test: passed",
    "color": "#A9E34B",
    "restricted": false
  },
  {
    "id": "6.2",
    "status": "Test: did not pass",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "7.0",
    "status": "Recruiter screen invite received",
    "color": "#38D9A9",
    "restricted": false,
    "common": "Recruiter screen stage"
  },
  {
    "id": "7.1",
    "status": "Recruiter screen scheduled",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "8.0",
    "status": "Recruiter screen happened",
    "color": "#4DABF7",
    "restricted": false
  },
  {
    "id": "9.1",
    "status": "Recruiter screen: passed",
    "color": "#9ae095",
    "text": "black",
    "restricted": false
  },
  {
    "id": "9.2",
    "status": "Recruiter screen: did not pass",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "10.0",
    "status": "Engineer screen scheduled",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false,
    "common": "Engineer screen stage"
  },
  {
    "id": "11.0",
    "status": "Engineer screen happened",
    "color": "#ffa6c1",
    "text": "black",
    "restricted": false
  },
  {
    "id": "12.1",
    "status": "Engineer screen: passed",
    "color": "#f797ef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "12.2",
    "status": "Engineer screen: did not pass",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "13.0",
    "status": "Onsite: invite received",
    "color": "#cff5d1",
    "text": "black",
    "restricted": false,
    "common": "Onsite stage"
  },
  {
    "id": "13.1",
    "status": "Onsite: scheduled",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "14.0",
    "status": "Onsite: happened",
    "color": "#166ee1",
    "text": "white",
    "restricted": false
  },
  {
    "id": "15.1",
    "status": "Onsite: succeeded",
    "color": "#39caff",
    "text": "black",
    "restricted": false
  },
  {
    "id": "15.2",
    "status": "Onsite: did not pass",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "16.0",
    "status": "Team matching scheduled",
    "color": "#048a0e",
    "text": "white",
    "restricted": false,
    "common": "Team matching stage"
  },
  {
    "id": "16.1",
    "status": "Team matching: rejected",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "17.0",
    "status": "Verbal offer received",
    "color": "#d54401",
    "text": "white",
    "restricted": false,
  },
  {
    "id": "18.0",
    "status": "Written offer received",
    "color": "#c4ecff",
    "text": "black",
    "restricted": false,
    "common": "Offer received"
  },
  {
    "id": "19.0",
    "status": "Offer accepted (not digitally signed)",
    "color": "#40C057",
    "restricted": false
  },
  {
    "id": "19.1",
    "status": "Offer declined by the fellow",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "19.2",
    "status": "Offer rescinded (without deadline)",
    "color": "#efefef",
    "text": "black",
    "restricted": false
  },
  {
    "id": "19.3",
    "status": "Offer deadline expired",
    "color": "#FF6B6B",
    "restricted": false
  },
  {
    "id": "20.0",
    "status": "Offer signed",
    "color": "#dd04a8",
    "text": "white",
    "restricted": false,
    "common": "Offer signed"
  },
  {
    "id": "21.0",
    "status": "Outtalent deprioritized",
    "color": "#41454d",
    "text": "white",
    "restricted": true
  }
]

export default applicationSteps

